import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Logo from "../../assets/Deloitte-Logo.png";
import AccountMenu from "./AccountMenu";
import AccountMenuNew from "./AccountMenuNew";
import "./Header.css";
import BackBtnHeader from "./BackBtnHeader";
import NavigationHeader from "./NavigationHeader";
import Seperator from "../Atoms/Seperator";
import NotificationCompo from "./Notifications/NotificationCompo";

function Header() {
  const { pathname } = useLocation();
  const accountMenuCheck = (pathname === '/' || pathname === '/not-authorize') ? true : false;


  return (
    <header className="header-container">
      <div className="header">
        <div className="header-right">
          <NotificationCompo />
          {!accountMenuCheck && <AccountMenuNew />}
          {/* {!accountMenuCheck && <AccountMenu />} */}
        </div>
        <div className="header-left">
          <img src={Logo} className="LogoImage" alt="logo" />
          <h3 className="LogoHeading">Marketplace</h3>
        </div>
      </div>
      <NavigationHeader />
      <BackBtnHeader />
    </header>
  );
}

export default Header;